import { Event } from '.';
const FoquzEvent = Event();

const MailingActivateEvent = FoquzEvent.get('mailing.activate');
const MailingToggleTypeEvent = FoquzEvent.get('mailing.toggle.type');
export { MailingActivateEvent, MailingToggleTypeEvent };
